<template>
  <div>
    <div class="col-lg-12" style="padding-top: 20px; padding-bottom: 20px">
      <div class="row">
        <div class="col-lg-2">
          <el-select placeholder="Select customer" v-model="selects.assigner" @change="getAssigner()" filterable>
            <el-option v-for="option in selects.assigners" class="select-info custom-option" :value="option.value"
              :label="option.label" :key="option.value"></el-option>
          </el-select>
        </div>
        <div class="col-lg-2">
          <el-select placeholder="Select service location" v-model="selects.servicelocation" @change="getAssigner()"
            filterable>
            <el-option v-for="option in selects.servicelocations" class="select-info custom-option"
              :value="option.value" :label="option.label" :key="option.value"></el-option>
          </el-select>
        </div>
        <div class="col-lg-2">
          <el-select placeholder="Select job status" v-model="selects.status" @change="getDatabyCompany()" filterable>
            <el-option v-for="option in selects.statuses" class="select-info custom-option" :value="option.value"
              :label="option.label" :key="option.value"></el-option>
          </el-select>
        </div>
        <div class="col-lg-2">
          <el-select placeholder="Select quotation status" v-model="selects.quostatus" @change="getDatabyCompany()"
            filterable>
            <el-option v-for="option in selects.quostatuses" class="select-info custom-option" :value="option.value"
              :label="option.label" :key="option.value"></el-option>
          </el-select>
        </div>
        <div class="col-lg"></div>
        <div class="col-lg-2">
          <!-- <base-input style="border: none"> -->
          <el-input type="search" class="mb-3 search-input" prefix-icon="el-icon-search"
            placeholder="Search Job, Cust..." v-model="searchQuery" aria-controls="datatables"></el-input>
          <!-- </base-input> -->
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <div class="tabs">
            <div class="tab-list" style="display: flex">
              <div v-for="(tab, index) in tabs" :key="index" :class="{
                'first-tab': index === 0,
                'other-tab': index !== 0 && index !== 5,
                'last-tab': index === 5,
                'inactive-tab': activeTab !== index,
              }" @click="activeTab = index" style="z-index: 999">
                <p :class="{
                  'active-tab-title': activeTab === index,
                  'inactive-tab-title': activeTab !== index,
                }" style="align-items: center">
                  <!-- display flex -->
                  <!-- <span class="dot"
                    :style="{ width: '10px', height: '10px', 'background-color': tab.pending ? 'red' : 'transparent', 'border-radius': '50%', 'margin-right': '5px', }"></span>&nbsp;&nbsp;&nbsp; -->
                  {{ tab.name }}
                </p>
              </div>
            </div>
            <card class="card-eprf">
              <!-- non vessel -->
              <div class="row" style="display: flex" v-if="selects.type != 'vessel'">
                <div class="col-lg-2">
                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                    LIST OF JOBS
                  </p>
                </div>
                <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
                <!-- non-vessel -->

                <div style="width: 100px; display: flex">
                  <div style="
                      width: 6px;
                      background-color: #0baa00;
                      color: #0baa00;
                    ">
                    .
                  </div>
                  &nbsp;&nbsp;&nbsp;
                  <p style="
                      font-size: 15px;
                      margin: auto;
                      font-weight: 300;
                      color: #A5A5A5;
                    ">
                    &lt; 48 Hours
                  </p>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div style="width: 100px; display: flex">
                  <div style="
                      width: 6px;
                      background-color: #ff9900;
                      color: #ff9900;
                    ">
                    .
                  </div>
                  &nbsp;&nbsp;&nbsp;
                  <p style="
                      font-size: 15px;
                      margin: auto;
                      font-weight: 300;
                      color: #A5A5A5;
                    ">
                    &gt; 48 Hours
                  </p>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div style="width: 100px; display: flex">
                  <div style="
                      width: 6px;
                      background-color: #ff0000;
                      color: #ff0000;
                    ">
                    .
                  </div>
                  &nbsp;&nbsp;&nbsp;
                  <p style="
                      font-size: 15px;
                      margin: auto;
                      font-weight: 300;
                      color: #A5A5A5;
                    ">
                    &gt; 72 Hours
                  </p>
                </div>
              </div>
              <!-- vessel -->
              <div class="row" style="display: flex" v-if="selects.type == 'vessel'">
                <div class="col-lg-2">
                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                    LIST OF JOBS
                  </p>
                </div>
                <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
                <!-- non-vessel -->

                <div style="width: 100px; display: flex">
                  <div style="
                      width: 6px;
                      background-color: #0baa00;
                      color: #0baa00;
                    ">
                    .
                  </div>
                  &nbsp;&nbsp;&nbsp;
                  <p style="
                      font-size: 15px;
                      margin: auto;
                      font-weight: 300;
                      color: #A5A5A5;
                    ">
                    &lt; 6 Hours
                  </p>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div style="width: 100px; display: flex">
                  <div style="
                      width: 6px;
                      background-color: #ff9900;
                      color: #ff9900;
                    ">
                    .
                  </div>
                  &nbsp;&nbsp;&nbsp;
                  <p style="
                      font-size: 15px;
                      margin: auto;
                      font-weight: 300;
                      color: #A5A5A5;
                    ">
                    &gt;= 6 Hours
                  </p>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div style="width: 100px; display: flex">
                  <div style="
                      width: 6px;
                      background-color: #ff0000;
                      color: #ff0000;
                    ">
                    .
                  </div>
                  &nbsp;&nbsp;&nbsp;
                  <p style="
                      font-size: 15px;
                      margin: auto;
                      font-weight: 300;
                      color: #A5A5A5;
                    ">
                    &gt;= 12 Hours
                  </p>
                </div>
              </div>

              <div id="tableku" v-if="this.load == false">
                <el-table :data="queriedData" :header-cell-style="{
                  background: 'transparent',
                  color: 'gray',
                }" class="custom-table" style="width: 100%; height: 800px; overflow: auto">
                  <el-table-column :min-width="50" align="center" prop="index" label="NO">
                  </el-table-column>
                  <el-table-column :min-width="200" align="center" prop="jobno" label="REFERENCE NO">
                    <div slot-scope="{ row }">
                      <p class="job-no-title" :style="{ color: colors.primary }" @click="getJobPage(row)">
                        {{ row.jobno }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column :min-width="200" sortable align="center" prop="datecreated" label="DATE CREATED">
                    <div slot-scope="{ row }">
                      {{ moment(row.datecreated).format(
                        "DD MMM YYYY"
                      ) }}</div>
                  </el-table-column>
                  <el-table-column :min-width="200" sortable align="center" prop="customer"
                    label="CUSTOMER"></el-table-column>
                  <el-table-column :min-width="200" sortable align="center" prop="duedate"
                    label="DUE DATE">
                    <div slot-scope="{ row }">
                      {{ moment(row.duedate).format(
                        "DD MMM YYYY"
                      ) }}</div>
                  </el-table-column>
                  <el-table-column :min-width="200" align="center" prop="jobduration" label="JOB DURATION (in hours)"
                    v-if="activeTab != 0 && activeTab != 5">
                    <div slot-scope="{ row }">
                      <p style="color: #707b79" v-if="
                        row.jobdurationinHours == 0 ||
                        row.jobdurationinHours == '-'
                      ">
                        {{ row.jobduration }}
                      </p>
                      <p style="color: #0baa00" v-if="
                        row.jobdurationinHours > 0 &&
                        row.jobdurationinHours <= 48
                      ">
                        {{ row.jobduration }}
                      </p>
                      <p style="color: #ff9900" v-if="
                        row.jobdurationinHours > 48 &&
                        row.jobdurationinHours < 72
                      ">
                        {{ row.jobduration }}
                      </p>
                      <p style="color: #ff0000" v-if="row.jobdurationinHours >= 72">
                        {{ row.jobduration }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column :min-width="200" align="center" prop="jobduration" label="JOB DURATION (in hours)"
                    v-if="activeTab == 0">
                    <div slot-scope="{ row }">
                      <p style="color: #707b79" v-if="
                        row.jobdurationinHours == 0 ||
                        row.jobdurationinHours == '-'
                      ">
                        {{ row.jobduration }}
                      </p>
                      <p style="color: #0baa00" v-if="
                        row.jobdurationinHours > 0 &&
                        row.jobdurationinHours < 6
                      ">
                        {{ row.jobduration }}
                      </p>
                      <p style="color: #ff9900" v-if="
                        row.jobdurationinHours >= 6 &&
                        row.jobdurationinHours < 12
                      ">
                        {{ row.jobduration }}
                      </p>
                      <p style="color: #ff0000" v-if="row.jobdurationinHours >= 12">
                        {{ row.jobduration }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column :min-width="200" align="center" prop="jobstatus" label="JOB STATUS">
                    <div slot-scope="{ row }">
                      <p style="color: #0baa00" v-if="
                        row.jobstatus == 'Completed' ||
                        row.jobstatus == 'Accepted'
                      ">
                        {{ row.jobstatus }}
                      </p>
                      <p style="color: #ff0000" v-else-if="row.jobstatus == 'Pending'">
                        {{ row.jobstatus }}
                      </p>
                      <p class="job-no-title2" style="color: #ff0000" v-else-if="row.jobstatus == 'Disputed'"
                        @click="getDisputeReason(row, 'job')">
                        {{ row.jobstatus }}
                      </p>
                      <p v-else style="color: #A5A5A5">
                        {{ row.jobstatus }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column v-if="
                    selects.type == 'vessel' ||
                    selects.type == 'land' ||
                    selects.type == 'scrap' ||
                    selects.type == 'garbage'
                  " :min-width="200" align="center" prop="quotation" label="QUOTATION">
                    <div slot-scope="{ row }">
                      <p style="color: #0baa00" v-if="row.flag == 'Completed'">
                        {{ row.quotation }}
                      </p>
                      <p style="color: #ff0000" v-else-if="row.flag == 'Pending'">
                        {{ row.quotation }}
                      </p>
                      <p class="job-no-title2" v-else-if="row.flag == 'Rejected'" @click="getDisputeReason(row, 'quo')">
                        {{ row.quotation }}
                      </p>
                      <p v-else style="color: #A5A5A5">
                        {{ row.quotation }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column v-if="selects.type == 'vessel' || selects.type == 'land'" :min-width="200"
                    align="center" prop="ptw" label="PTW">
                    <div slot-scope="{ row }">
                      <p style="color: #0baa00" v-if="row.ptw == 'Completed'">
                        {{ row.ptw }}
                      </p>
                      <p style="color: #ff0000" v-else-if="row.ptw == 'Pending'">
                        {{ row.ptw }}
                      </p>
                      <p style="color: #A5A5A5" v-else>
                        {{ row.ptw }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column v-if="selects.type == 'tyre'" :min-width="200" align="center" prop="invoice"
                    label="INVOICE">
                    <div slot-scope="{ row }">
                      <p style="color: #0baa00" v-if="row.invoice == 'Completed'">
                        Completed
                      </p>
                      <p style="color: #ff0000" v-if="row.invoice == 'Pending'">
                        Pending
                      </p>
                      <p style="color: #A5A5A5" v-if="
                        row.invoice != 'Pending' && row.invoice != 'Completed'
                      ">
                        {{ row.invoice }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column v-if="
                    selects.type == 'scrap' ||
                    selects.type == 'tyre' ||
                    selects.type == 'garbage'
                  " :min-width="200" align="center" prop="gatepass" label="GATEPASS">
                    <div slot-scope="{ row }">
                      <p style="color: #0baa00" v-if="row.gatepass == 'Completed'">
                        {{ row.gatepass }}
                      </p>
                      <p style="color: #ff0000" v-else-if="row.gatepass == 'Pending'">
                        {{ row.gatepass }}
                      </p>
                      <p style="color: #A5A5A5" v-else>
                        {{ row.gatepass }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column v-if="selects.type == 'land'" :min-width="200" align="center" label="LABEL">
                    <div slot-scope="{ row }">
                      <base-button class="btn-link btn-primary" @click="downloadQR(row.jobno)">Generate
                        Label</base-button>
                    </div>
                  </el-table-column>
                  <!-- <el-table-column
                  :min-width="200"
                  align="center"
                  prop="labreport"
                  label="LAB REPORT"
                >
                  <div slot-scope="{ row }">
                    <p
                      style="color: #0baa00"
                      v-if="row.labreport == 'Complete'"
                    >
                      {{ row.labreport }}
                    </p>
                    <p style="color: #ff0000" v-if="row.labreport == 'Pending'">
                      {{ row.labreport }}
                    </p>
                    <p
                      style="color: #A5A5A5"
                      v-if="
                        row.labreport != 'Pending' &&
                        row.labreport != 'Complete'
                      "
                    >
                      {{ row.labreport }}
                    </p>
                  </div>
                </el-table-column> -->
                  <el-table-column v-if="selects.type == 'vessel' || selects.type == 'land'" :min-width="200"
                    align="center" prop="wdr" label="WDR">
                    <div slot-scope="{ row }">
                      <p style="color: #0baa00" v-if="row.wdr == 'Completed'">
                        Completed
                      </p>
                      <p style="color: #ff0000" v-if="row.wdr == 'Pending'">
                        Pending
                      </p>
                      <p style="color: #A5A5A5" v-if="row.wdr != 'Pending' && row.wdr != 'Completed'">
                        {{ row.wdr }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column v-if="selects.type == 'scrap' || selects.type == 'tyre'" :min-width="200"
                    align="center" prop="wdo" label="WDO">
                    <div slot-scope="{ row }">
                      <p style="color: #0baa00" v-if="row.wdo == 'Completed'">
                        Completed
                      </p>
                      <p style="color: #ff0000" v-if="row.wdo == 'Pending'">
                        Pending
                      </p>
                      <p style="color: #A5A5A5" v-if="row.wdo != 'Pending' && row.wdo != 'Completed'">
                        {{ row.wdo }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column v-if="selects.type == 'garbage'" :min-width="200" align="center" prop="wdo"
                    label="WDO / WEIGHT RECEIPT">
                    <div slot-scope="{ row }">
                      <p style="color: #0baa00" v-if="row.wdo == 'Completed'">
                        Completed
                      </p>
                      <p style="color: #ff0000" v-if="row.wdo == 'Pending'">
                        Pending
                      </p>
                      <p style="color: #A5A5A5" v-if="row.wdo != 'Pending' && row.wdo != 'Completed'">
                        {{ row.wdo }}
                      </p>
                    </div>
                  </el-table-column>
                  <el-table-column v-if="
                    selects.type == 'garbage' ||
                    selects.type == 'vessel' ||
                    selects.type == 'land' ||
                    selects.type == 'scrap'
                  " :min-width="200" align="center" prop="invoice" label="INVOICE">
                    <div slot-scope="{ row }">
                      <p style="color: #0baa00" v-if="row.invoice == 'Completed'">
                        Completed
                      </p>
                      <p style="color: #ff0000" v-if="row.invoice == 'Pending'">
                        Pending
                      </p>
                      <p style="color: #A5A5A5" v-if="
                        row.invoice != 'Pending' && row.invoice != 'Completed'
                      ">
                        {{ row.invoice }}
                      </p>
                    </div>
                  </el-table-column>
                </el-table>
              </div>
            </card>
            <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <el-select v-model="pagination.perPage" placeholder="Per page">
                <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
                  :value="item"></el-option>
              </el-select>

              <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                :per-page="pagination.perPage" :total="total"></base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal :show.sync="modals.viewrejectreason" class="modal-eprf" centered>
      <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
        header="REASON FOR DISPUTE" header-bg-variant="primary" header-text-variant="white">
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">REASON FOR DISPUTE</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.viewrejectreason = false"></i>
              </base-button>
            </div>
          </div>
        </template>

        <div class="row">
          <div class="col-lg-12">
            <textarea type="textarea" placeholder="Reason for rejection..." v-model="reason" :class="{ textarea: true }"
              disabled></textarea>
          </div>
        </div>
      </b-card>
    </modal>
  </div>
</template>

<script>
import {
  Alert,
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../../util/util";
import Card from "../../../components/Cards/Card.vue";
import { BasePagination, BaseSwitch } from "../../../../src/components";
import jsPDF from "jspdf";
import { debounce } from "src/util/debounce";
import { colors } from "../../../components/colors.js";
import moment from "moment";
import QRCode from "qrcode";
import Fuse from "fuse.js";
import { Modal } from "@/components";
import { BCard } from "bootstrap-vue";

export default {
  name: "Incoming",

  components: {
    Card,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Fuse,
    Circle8,
    [Select.name]: Select,
    [Option.name]: Option,
    Modal,
    BCard,
  },

  data() {
    return {
      havePending: false,
      activeTab: "",
      tabs: [
        { name: "Vessel", content: "Content for Tab 1", pending: false },
        { name: "SW", content: "Content for Tab 2", pending: false },
        { name: "Scrap", content: "Content for Tab 3", pending: false },
        { name: "Garbage", content: "Content for Tab 4", pending: false },
        { name: "Tyre", content: "Content for Tab 5", pending: false },
        { name: "Others", content: "Content for Tab 6", pending: false },
      ],
      reason: "",
      modals: {
        viewrejectreason: false,
      },
      jobnum: "",
      colors: colors,
      cellStyle: {
        background: "transparent",
        color: "gray",
      },

      selectedFileName: "",
      allfilename: [],
      tableDatas: [],

      load: false,

      jobno: [
        {
          prop: "jobno",
          label: "REFERENCE NO",
        },
      ],
      joblist: [
        {
          prop: "customer",
          label: "CUSTOMER",
        },
        {
          prop: "duedate",
          label: "DUE DATE",
        },
      ],

      selects: {
        assigner: "",
        assigners: [
          { value: "00", label: "All" },
          { value: "01", label: "Yahya Abd Rahman" },
          { value: "02", label: "Ikhwan Ayub" },
          { value: "03", label: "Haziq Haikal" },
        ],
        status: "",
        statuses: [],
        type: "",
        quostatus: "",
        quostatuses: [],
        servicelocation: "",
        servicelocations: [],
      },

      temp: [],
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 25, 50],
        total: 0,
      },
    };
  },
  methods: {
    getStatus() {
      this.selects.statuses = [];

      this.$http.get(":10001/api/v1/incoming/status").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].id,
            };
            this.selects.statuses.push(obj);
          }
        }
      });
    },
    getQuoStatus() {
      this.selects.statuses = [];

      this.$http.get(":10001/api/v1/incoming/quostatus").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].id,
            };
            this.selects.quostatuses.push(obj);
          }
        }
      });
    },
    getDisputeReason(row, flag) {
      console.log(row);
      if (flag == "quo") {
        this.reason = row.disputereason;
        this.modals.viewrejectreason = true;
      }
      if (flag == "job") {
        this.reason = row.jobdisputereason;
        this.modals.viewrejectreason = true;
      }
    },
    getAssigner() {
      if (this.selects.assigner == "All") {
        this.getData();
      } else {
        this.getDatabyCompany();
      }
    },
    getDatabyCompany() {
      this.tableDatas = [];
      this.temp = [];
      let comp = "";
      if (this.selects.assigner == "All") {
        comp = "";
      } else {
        comp = this.selects.assigner;
      }

      console.log(this.selects.type);
      if (this.selects.type == "vessel" || this.selects.type == "land") {
        this.$http
          .get(
            ":10001/api/v1/incoming?company_id=" +
            comp +
            "&type=" +
            this.selects.type +
            "&status=" +
            this.selects.status +
            "&quostatus=" +
            this.selects.quostatus +
            "&service_location_id=" +
            this.selects.servicelocation
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              for (var i = 0; i < response.length; i++) {
                // console.log(response[i].duration);
                let obj = {
                  index:
                    i +
                    1 +
                    this.pagination.perPage * (this.pagination.currentPage - 1),
                  jobno: response[i].reference_no,
                  // NGL - land, NPV - vessel
                  //jobflag: response[i].company_type,
                  datecreated: response[i].created_at,
                  // moment(response[i].created_at).format(
                  // "DD MMM YYYY"
                  // ),
                  customer: response[i].company_name,
                  duedate: 
                  // moment(
                    response[i].arrival_eta
                  // ).format(
                    // "DD MMM YYYY"
                  // )
                  ,
                  jobduration: response[i].duration,

                  jobdurationinHours:
                    response[i].duration == "-"
                      ? "-"
                      : parseInt(response[i].duration),
                  flag: this.camelCase(response[i].quotation_status_text).split(
                    " "
                  )[0],
                  jobstatus: this.camelCase(response[i].waste_job_status_text),
                  quotation:
                    response[i].quotation_status_text == "-"
                      ? "-"
                      : this.camelCase(response[i].quotation_status_text),
                  ptw:
                    response[i].permit_to_work_status_text == "-"
                      ? "-"
                      : this.camelCase(response[i].permit_to_work_status_text),
                  labreport: response[i].lab_report_status_text,
                  wdr:
                    response[i].waste_disposal_status_text == "-"
                      ? "-"
                      : this.camelCase(response[i].waste_disposal_status_text),
                  invoice:
                    response[i].invoice_status_text == "-"
                      ? "-"
                      : this.camelCase(response[i].invoice_status_text),
                  // disputereason: response[i].dispute_reason,
                  disputereason: response[i].quotation_dispute_reason,
                  jobdisputereason: response[i].dispute_reason,
                };

                this.tableDatas.push(obj);
                this.temp.push(obj);
              }
            }
          });
      }

      if (this.selects.type == "scrap") {
        this.$http
          .get(
            ":10001/api/v1/incoming/scrap?" +
            "&status=" +
            this.selects.status +
            "&quostatus=" +
            this.selects.quostatus +
            "&service_location_id=" +
            this.selects.servicelocation
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              // console.log(response);
              for (var i = 0; i < response.length; i++) {
                let obj = {
                  index:
                    i +
                    1 +
                    this.pagination.perPage * (this.pagination.currentPage - 1),
                  jobno: response[i].reference_no,
                  // NGL - land, NPV - vessel
                  jobflag: "",
                  datecreated: response[i].date_created,
                  // datecreated: moment(response[i].date_created).format(
                  //   "DD MMM YYYY"
                  // ),
                  customer: response[i].company.company_name,
                  duedate: 
                  // moment(
                    response[i].collection_date
                  // ).format(
                    // "DD MMM YYYY"
                  // )
                  ,
                  jobduration: response[i].duration,

                  jobdurationinHours:
                    response[i].duration == "-"
                      ? "-"
                      : parseInt(response[i].duration),
                  flag: this.camelCase(response[i].quotation_text).split(
                    " "
                  )[0],
                  jobstatus: this.camelCase(response[i].waste_job_status_text),
                  quotation:
                    response[i].quotation_text == "-"
                      ? "-"
                      : this.camelCase(response[i].quotation_text),
                  ptw:
                    response[i].ptw_text == "-"
                      ? "-"
                      : this.camelCase(response[i].ptw_text),

                  wdo:
                    response[i].wdo_text == "-"
                      ? "-"
                      : this.camelCase(response[i].wdo_text),
                  invoice:
                    response[i].invoice_text == "-"
                      ? "-"
                      : this.camelCase(response[i].invoice_text),
                  gatepass:
                    response[i].gate_pass_text == "-"
                      ? "-"
                      : this.camelCase(response[i].gate_pass_text),
                  // disputereason: response[i].dispute_reason,
                  disputereason: response[i].quotation_dispute_reason,
                  jobdisputereason: response[i].dispute_reason,
                };

                this.tableDatas.push(obj);
                this.temp.push(obj);
              }
            }
          });
      }

      if (this.selects.type == "garbage") {
        this.$http
          .get(
            ":10001/api/v1/incoming/garbage?" +
            "&status=" +
            this.selects.status +
            "&quostatus=" +
            this.selects.quostatus +
            "&service_location_id=" +
            this.selects.servicelocation
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              for (var i = 0; i < response.length; i++) {
                let obj = {
                  index:
                    i +
                    1 +
                    this.pagination.perPage * (this.pagination.currentPage - 1),
                  jobno: response[i].reference_no,
                  // NGL - land, NPV - vessel
                  jobflag: "",
                  datecreated: response[i].date_created,
                  // datecreated: moment(response[i].date_created).format(
                  //   "DD MMM YYYY"
                  // ),
                  customer: response[i].company.company_name,
                  duedate: 
                  // moment(
                    response[i].collection_date
                  // ).format(
                    // "DD MMM YYYY"
                  // )
                  ,
                  jobduration: response[i].duration,

                  jobdurationinHours:
                    response[i].duration == "-"
                      ? "-"
                      : parseInt(response[i].duration),
                  flag: this.camelCase(response[i].quotation_text).split(
                    " "
                  )[0],
                  jobstatus: this.camelCase(response[i].waste_job_status_text),
                  quotation:
                    response[i].quotation_text == "-"
                      ? "-"
                      : this.camelCase(response[i].quotation_text),
                  // ptw:
                  //   response[i].ptw_text == "-"
                  //     ? "-"
                  //     : this.camelCase(response[i].ptw_text),

                  wdo:
                    response[i].wdo_text == "-"
                      ? "-"
                      : this.camelCase(response[i].wdo_text),
                  invoice:
                    response[i].invoice_text == "-"
                      ? "-"
                      : this.camelCase(response[i].invoice_text),
                  gatepass:
                    response[i].gate_pass_text == "-"
                      ? "-"
                      : this.camelCase(response[i].gate_pass_text),
                  // disputereason: response[i].dispute_reason,
                  disputereason: response[i].quotation_dispute_reason,
                  jobdisputereason: response[i].dispute_reason,
                };

                this.tableDatas.push(obj);
                this.temp.push(obj);
              }
            }
          });
      }

      if (this.selects.type == "tyre") {
        this.$http
          .get(
            ":10001/api/v1/incoming/tyre?" +
            "&status=" +
            this.selects.status +
            "&quostatus=" +
            this.selects.quostatus +
            "&service_location_id=" +
            this.selects.servicelocation
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              for (var i = 0; i < response.length; i++) {
                let obj = {
                  index:
                    i +
                    1 +
                    this.pagination.perPage * (this.pagination.currentPage - 1),
                  jobno: response[i].reference_no,
                  // NGL - land, NPV - vessel
                  jobflag: "",
                  jobstatus: this.camelCase(response[i].waste_job_status_text),
                  // datecreated: moment(response[i].date_created).format(
                  //   "DD MMM YYYY"
                  // ),
                  datecreated: response[i].date_created,
                  customer: response[i].company.company_name,
                  duedate: 
                  // moment(
                    response[i].collection_date
                  // ).format(
                    // "DD MMM YYYY"
                  // )
                  ,
                  jobduration: response[i].duration,

                  jobdurationinHours:
                    response[i].duration == "-"
                      ? "-"
                      : parseInt(response[i].duration),
                  // flag: this.camelCase(response[i].quotation_text).split(
                  //   " "
                  // )[0],
                  // quotation:
                  //   response[i].quotation_text == "-"
                  //     ? "-"
                  //     : this.camelCase(response[i].quotation_text),
                  // ptw:
                  //   response[i].ptw_text == "-"
                  //     ? "-"
                  //     : this.camelCase(response[i].ptw_text),

                  wdo:
                    response[i].wdo_text == "-"
                      ? "-"
                      : this.camelCase(response[i].wdo_text),
                  invoice:
                    response[i].invoice_text == "-"
                      ? "-"
                      : this.camelCase(response[i].invoice_text),
                  gatepass:
                    response[i].gate_pass_text == "-"
                      ? "-"
                      : this.camelCase(response[i].gate_pass_text),
                  // disputereason: response[i].dispute_reason,
                  disputereason: response[i].quotation_dispute_reason,
                  jobdisputereason: response[i].dispute_reason,
                };

                this.tableDatas.push(obj);
                this.temp.push(obj);
              }
            }
          });
      }

      if (this.selects.type == "other") {
        this.$http
          .get(
            ":10001/api/v1/incoming/others?" +
            "&status=" +
            this.selects.status +
            "&quostatus=" +
            this.selects.quostatus +
            "&service_location_id=" +
            this.selects.servicelocation
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              for (var i = 0; i < response.length; i++) {
                let obj = {
                  index:
                    i +
                    1 +
                    this.pagination.perPage * (this.pagination.currentPage - 1),
                  jobno: response[i].reference_no,
                  // NGL - land, NPV - vessel
                  jobflag: "",
                  jobstatus: this.camelCase(response[i].waste_job_status_text),
                  // datecreated: moment(response[i].date_created).format(
                  //   "DD MMM YYYY"
                  // ),
                  datecreated: response[i].date_created,
                  customer: response[i].company.company_name,
                  duedate: 
                  // moment(
                    response[i].collection_date
                  // ).format(
                    // "DD MMM YYYY"
                  // )
                  ,
                  // jobduration: response[i].duration,

                  // jobdurationinHours: parseInt(response[i].duration),
                  // flag: this.camelCase(response[i].quotation_text).split(
                  //   " "
                  // )[0],
                  // quotation:
                  //   response[i].quotation_text == "-"
                  //     ? "-"
                  //     : this.camelCase(response[i].quotation_text),
                  // ptw:
                  //   response[i].ptw_text == "-"
                  //     ? "-"
                  //     : this.camelCase(response[i].ptw_text),

                  // wdo:
                  //   response[i].wdo_text == "-"
                  //     ? "-"
                  //     : this.camelCase(response[i].wdo_text),
                  // invoice:
                  //   response[i].invoice_text == "-"
                  //     ? "-"
                  //     : this.camelCase(response[i].invoice_text),
                  // gatepass: response[i].gate_pass_text == "-"
                  //     ? "-"
                  //     : this.camelCase(response[i].gate_pass_text),
                  // disputereason: response[i].dispute_reason,
                  // disputereason: response[i].quotation_dispute_reason,
                };

                this.tableDatas.push(obj);
                this.temp.push(obj);
              }
            }
          });
      }
    },
    downloadQR(refno) {
      this.$router.push("/Incoming/" + refno);
      // console.log(refno)
      // const image = new Image();
      // image.src = require("@/assets/img/afes.png");
      // image.onload = () => {
      //   this.options = Object.assign({}, this.options, {
      //     logo: {
      //       image,
      //     },
      //   });
      // };

      // let doc = jsPDF({
      //   orientation: "potrait",
      //   format: [1070, 1240],
      // });
      // let QRs = [];
      // QRs.push(
      //     QRCode.toDataURL(refno)
      //       .then((url) => {
      //         let obj = {};
      //         obj["id"] = url;
      //         // obj["ownedby"] = this.multipleSelection[i].ownedby;
      //         obj["refno"] = refno;
      //         return obj;
      //       })
      //       .catch((err) => {
      //         console.error(err);
      //       })
      //   );

      //   Promise.all(QRs).then((QR) => {
      //   for (let i = 0; i < QR.length; i++) {
      //     let AssetNo = QR[i].refno.split(" ");
      //     AssetNo.push(" ");
      //     AssetNo.push(" ");
      //     AssetNo.push(" ");
      //     AssetNo.push(" ");
      //     AssetNo.push(" ");
      //     console.log(refno);
      //     var img = new Image();
      //     img.src = require("@/assets/img/afes.png");
      //     doc.addImage(QR[i].id, "JPEG", -10, -20, 420, 420);
      //     // (data, format, x, y, width, height)
      //     doc.addImage(img, "JPEG", 20, 340, 90, 80);
      //     if (AssetNo.length < 3) {
      //       doc.text(AssetNo[0] + " " + AssetNo[1], 200, 380, "center");
      //     } else if (AssetNo.length < 5) {
      //       doc.text(AssetNo[0] + " " + AssetNo[1], 200, 380, "center");
      //       doc.text(AssetNo[2] + " " + AssetNo[3], 230, 405, "center");
      //     } else {
      //       doc.text(AssetNo[0] + " " + AssetNo[1], 200, 380, "center");
      //       doc.text(AssetNo[2] + " " + AssetNo[3], 230, 405, "center");
      //       doc.text(AssetNo[4] + " " + AssetNo[5], 230, 430, "center");
      //     }
      //     if (i != QR.length - 1) {
      //       doc.addPage();
      //     }
      //   }
      //   doc.save(`QR.pdf`);
      // });
    },
    camelCase(str) {
      // console.log(str)
      if (str != "") {
        var splitStr = str.toLowerCase().split(" ");
        for (var i = 0; i < splitStr.length; i++) {
          // You do not need to check if i is larger than splitStr length, as your for does that for you
          // Assign it back to the array
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(" ");
      }
    },
    getJobPage(data) {
      // console.log(data);

      // sessionStorage.setItem("jobnum", this.jobnum);

      if (this.selects.type == "vessel" || this.selects.type == "land") {
        if (data.flag.toUpperCase() == "PENDING") {
          this.jobnum = data.jobno + "_quotation";
        } else if (data.ptw.toUpperCase() == "PENDING") {
          this.jobnum = data.jobno + "_ptw";
        } else {
          this.jobnum = data.jobno + "_none";
        }
        this.$router.push("/JobPage/" + this.jobnum);
      }

      if (this.selects.type == "scrap") {
        this.$router.push("/ScrapJobPage/" + data.jobno);
      }

      if (this.selects.type == "garbage") {
        this.$router.push("/GarbageJobPage/" + data.jobno);
      }

      if (this.selects.type == "tyre") {
        this.$router.push("/TyreJobPage/" + data.jobno);
      }

      if (this.selects.type == "other") {
        this.$router.push("/OtherJobPage/" + data.jobno);
      }
    },

    getData() {
      this.tableDatas = [];
      this.temp = [];

      this.$http
        .get(":10001/api/v1/incoming?type=" + this.selects.type)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              let obj = {
                index:
                  i +
                  1 +
                  this.pagination.perPage * (this.pagination.currentPage - 1),
                jobno: response[i].reference_no,
                // NGL - land, NPV - vessel
                jobflag: response[i].company_type,
                // datecreated: moment(response[i].created_at).format(
                //   "DD MMM YYYY"
                // ),
                datecreated: response[i].created_at,
                customer: response[i].company_name,
                duedate: 
                // moment(
                  response[i].arrival_eta
                // ).format("DD MMM YYYY")
                ,
                jobduration: response[i].duration,
                jobdurationinHours:
                  response[i].duration == "-"
                    ? 0
                    : parseInt(response[i].duration),
                flag: this.camelCase(response[i].quotation_status_text).split(
                  " "
                )[0],
                quotation:
                  response[i].quotation_status_text == "-"
                    ? "-"
                    : this.camelCase(response[i].quotation_status_text),
                ptw:
                  response[i].permit_to_work_status_text == "-"
                    ? "-"
                    : this.camelCase(response[i].permit_to_work_status_text),
                labreport: response[i].lab_report_status_text,
                wdr: response[i].waste_disposal_status_text,
                invoice: response[i].invoice_status_text,
                disputereason: response[i].quotation_dispute_reason,
                jobdisputereason: response[i].dispute_reason,
              };

              this.tableDatas.push(obj);
              this.temp.push(obj);
            }
          }
        });

      // var obj = {
      //   jobno: "hi",
      //   customer: "Garuda Logistics Sdn Bhd",
      //   duedate: "",
      //   jobduration: "13H 30M",
      //   quote: "Complete",
      //   ptw: "Complete",
      //   labreport: "-",
      //   wdr: "-",
      //   invoice: "-",
      // };

      // this.tableDatas.push(obj);
      // this.temp.push(this.tableDatas);
    },
    getCustomer() {
      this.selects.assigners = [];

      this.$http.get(":10001/api/v1/user-management/customer").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          this.selects.assigners = [
            {
              label: "All",
              value: "All",
            },
          ];
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].company_name,
              value: response[i].company_id,
            };
            this.selects.assigners.push(obj);
          }
        }
      });
    },
    getServiceLocation() {
      this.selects.servicelocations = [];

      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].Location,
              value: response[i].ServiceLocationId,
            };
            this.selects.servicelocations.push(obj);
          }
        }
      });
    },
  },
  created() {
    this.getCustomer();
    this.getServiceLocation();
    this.getStatus();
    this.getQuoStatus();
    // this.getData();
    // this.selects.type = "vessel"
    console.log(sessionStorage.getItem("currenttab"));
    if (sessionStorage.getItem("currenttab") == "vessel") {
      this.activeTab = 0;
    } else if (sessionStorage.getItem("currenttab") == "land") {
      this.activeTab = 1;
    } else if (sessionStorage.getItem("currenttab") == "scrap") {
      this.activeTab = 2;
    } else if (sessionStorage.getItem("currenttab") == "garbage") {
      this.activeTab = 3;
    } else if (sessionStorage.getItem("currenttab") == "tyre") {
      this.activeTab = 4;
    } else if (sessionStorage.getItem("currenttab") == "other") {
      this.activeTab = 5;
    } else {
      this.activeTab = 0;
    }
  },
  computed: {
    queriedData() {
      let result = this.tableDatas;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDatas.length;
    },
  },
  watch: {
    activeTab() {
      console.log(this.activeTab);
      if (this.activeTab == 0) {
        this.selects.type = "vessel";
      }
      if (this.activeTab == 1) {
        this.selects.type = "land";
      }
      if (this.activeTab == 2) {
        console.log("this is scrap");
        this.selects.type = "scrap";
      }
      if (this.activeTab == 3) {
        console.log("this is garbage");
        this.selects.type = "garbage";
      }
      if (this.activeTab == 4) {
        console.log("this is tyre");
        this.selects.type = "tyre";
      }

      if (this.activeTab == 5) {
        console.log("this is others");
        this.selects.type = "other";
      }

      sessionStorage.setItem("currenttab", this.selects.type);
    },
    "selects.type"() {
      console.log(this.selects.type);
      this.getDatabyCompany();
    },
    searchQuery: debounce(function (search) {
      console.log(search);
      if (search != "") {
        this.tableDatas = this.temp.filter(
          (value) =>
            value.jobno.toLowerCase().includes(search.toLowerCase()) ||
            (value.jobflag &&
              value.jobflag.toLowerCase().includes(search.toLowerCase())) ||
            value.customer.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.tableDatas = this.temp;
      }
    }, 500),
    // searchQuery(value){
    //   if (this.searchQuery == "") {
    //     this.tableDatas = this.temp;
    //   }
    //   let result = this.tableDatas;

    //   if (value !== "") {
    //     result = this.fuseSearch.search(this.searchQuery);
    //   }
    //   this.searchedData = result;
    //   this.tableDatas = this.searchedData;
    // }

    queriedData: {
      handler(newData) {
        const tables = newData.some((row) =>
          [
            "jobstatus",
            "quotation",
            "ptw",
            "gatepass",
            "invoice",
            "wdr",
            "wdo",
          ].some(
            (prop) =>
              // ['jobstatus'].some(prop =>
              row[prop] === "Pending Afes"
          )
        );
        console.log("ni ke?" + tables);
        this.tabs[this.activeTab].pending = tables;
      },
      deep: true,
    },
  },

  mounted() {
    this.fuseSearch = new Fuse(this.temp, {
      keys: ["jobno", "customer", "duedate"],
      threshold: 0.3,
    });
  },
};
</script>
<style scoped>
.first-tab {
  cursor: pointer;
  border-top-left-radius: 10px;
  margin-right: 3px;
  background-color: white;
  box-shadow: inset;
  width: 150px;
  padding: 5px 20px;
  border-top: 5px solid #358CCB;
}

.other-tab {
  cursor: pointer;
  margin-right: 3px;
  background-color: white;
  box-shadow: inset;
  width: 150px;
  padding: 5px 20px;
  border-top: 5px solid #358CCB;
  color: #358CCB;
}

.last-tab {
  cursor: pointer;
  border-top-right-radius: 10px;
  margin-right: 3px;
  background-color: white;
  box-shadow: inset;
  width: 180px;
  padding: 5px 20px;
  border-top: 5px solid #358CCB;
}

.inactive-tab {
  background-color: #e6e6e6;
  border: none;
  color: #A5A5A5;
}

.active-tab-title {
  color: #358CCB;
  text-align: center;
}

.inactive-tab-title {
  color: #A5A5A5;
  text-align: center;
  border-top: 5px solid transparent;
}

.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.custom-dropdown .el-select-dropdown {
  background-color: #358CCB;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-dropdown1 .el-input {
  background-color: #358CCB;
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
  color: #A5A5A5 !important;
}

.job-no-title {
  color: #358CCB;
  text-decoration: none;
}

.job-no-title2 {
  color: #A5A5A5;
  text-decoration: none;
}

.job-no-title2:hover {
  color: #A5A5A5;
  text-decoration: underline;
  cursor: pointer;
}

.job-no-title:hover {
  color: #358CCB;
  text-decoration: underline;
  cursor: pointer;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}
</style>
